import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { auth, db } from '../firebase';
import "../App.css";
import {
    collection,
    addDoc,
    Timestamp,
    query,
    orderBy,
    onSnapshot,
    getDoc,
    deleteDoc,
    doc,
    updateDoc
} from 'firebase/firestore'

export default function Department() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [departments, setdepartments] = useState([]);
    const [searchText, setsearchText] = useState("");
    const [department, setdepartment] = useState("");
    const [updocid, setupdocid] = useState("");
    const [updepartment, setupdepartment] = useState("");

    // pagination states
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 10; // change this for more/less rows

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchPropid()
        });
    });

    const fetchPropid = async () => {
        if (userData && loadincount) {
            const docRef = doc(db, "users", userData.uid)
            const docSnap = await getDoc(docRef)
            if (docSnap.exists()) {
                fetchData1();
                setloadincount(false)
            }
        }
    }

    const fetchData1 = async () => {
        try {
            const q = query(collection(db, 'departments'), orderBy('createdAt', 'asc'))
            onSnapshot(q, (querySnapshot) => {
                setdepartments(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }

    const fetchData2 = async () => {
        try {
            const filteredData = departments.filter((item) =>
                item.data.department.toUpperCase().includes(searchText.toUpperCase())
            );
            setdepartments(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleSubmit = async () => {
        if (!department) {
            Toast.fire({ icon: "error", title: 'Please Enter Required Fields!!' });
            return;
        }
        await addDoc(collection(db, "departments"), {
            department: department,
            uid: userData.uid,
            createdAt: Timestamp.now(),
        });
        setdepartment("");
        fetchData1();
        Toast.fire({ icon: "success", title: 'Department Added Successfully!!' });
    }

    const handleDelete = async (docid) => {
        const taskDocRef = doc(db, 'departments', docid)
        await deleteDoc(taskDocRef)
        Toast.fire({ icon: "success", title: 'Department Deleted Successfully!!' });
        fetchData1();
    }

    const handleEdit = (id, department) => {
        setupdocid(id);
        setupdepartment(department);
    }

    const handleUpdate = async () => {
        if (!updepartment) {
            Toast.fire({ icon: "error", title: 'Please Enter Required Fields!!' });
            return;
        }
        await updateDoc(doc(db, "departments", updocid), {
            department: updepartment,
        });
        Toast.fire({ icon: "success", title: 'Department Updated Successfully!!' });
        fetchData1();
    }

    // Pagination calculations
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = departments.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(departments.length / recordsPerPage);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <div>
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| Department Mgmt ||</button>
                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Department</button><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input
                                    type="search"
                                    value={searchText}
                                    onChange={(e) => { setsearchText(e.target.value); setCurrentPage(1); }}
                                    className='form-control col-sm-4'
                                    placeholder='Type here......'
                                />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Department</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRecords.map((item, index) =>
                                            <tr key={item.id}>
                                                <td width="80">{indexOfFirstRecord + index + 1}</td>
                                                <td>{item.data.department}</td>
                                                <td>
                                                    <a onClick={() => handleEdit(item.id, item.data.department)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                    <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    <a
                                                        className="btn btn-sm bg-purple"
                                                        href={'view-products/' + item.id}
                                                    >
                                                        <i className="fa fa-eye"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Pagination Controls */}
                        <nav>
                            <ul className="pagination justify-content-center mt-2">
                                <li className={`page-item ${currentPage === 1 && 'disabled'}`}>
                                    <button className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</button>
                                </li>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li key={i + 1} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                        <button className="page-link" onClick={() => paginate(i + 1)}>{i + 1}</button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages && 'disabled'}`}>
                                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </section>
            </div>

            {/* Add Modal */}
            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Department</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>Department *</label>
                                    <input type="text" value={department} onChange={(e) => setdepartment(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleSubmit()} className="btn btn-primary" data-dismiss="modal">Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Modal */}
            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Department</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>Department *</label>
                                    <input type="text" value={updepartment} onChange={(e) => setupdepartment(e.target.value)} className="form-control" />
                                </div>
                            </div><br />
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
